import * as z from 'zod/mini'
import { isoDateTime } from '../../schemas/common'

/** A premise's calendar items in a window. Both bounds are instants (`toISOString`). */
export const getManagedEntityCalendarItemsQuery = z.object({
  start: z.optional(isoDateTime),
  end: z.optional(isoDateTime),
})
export type GetManagedEntityCalendarItemsQuery = z.infer<typeof getManagedEntityCalendarItemsQuery>
